/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminV1OrganizationsSelectedWorkoutTypesListParams,
  PaginatedSelectedWorkoutTypeList,
  PatchedSelectedWorkoutType,
  SelectedWorkoutType
} from '.././model';

import adminV1OrganizationsSelectedWorkoutTypesListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsSelectedWorkoutTypesCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsSelectedWorkoutTypesUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsSelectedWorkoutTypesPartialUpdateMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsSelectedWorkoutTypesList = (
    organizationId: number,
    params?: AdminV1OrganizationsSelectedWorkoutTypesListParams,
 options?: SecondParameter<typeof adminV1OrganizationsSelectedWorkoutTypesListMutator<PaginatedSelectedWorkoutTypeList>>,) => {
      return adminV1OrganizationsSelectedWorkoutTypesListMutator<PaginatedSelectedWorkoutTypeList>(
      {url: `/api/admin/v1/organizations/${organizationId}/selected_workout_types/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsSelectedWorkoutTypesCreate = (
    organizationId: number,
    selectedWorkoutType: NonReadonly<SelectedWorkoutType>,
 options?: SecondParameter<typeof adminV1OrganizationsSelectedWorkoutTypesCreateMutator<SelectedWorkoutType>>,) => {
      return adminV1OrganizationsSelectedWorkoutTypesCreateMutator<SelectedWorkoutType>(
      {url: `/api/admin/v1/organizations/${organizationId}/selected_workout_types/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selectedWorkoutType
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsSelectedWorkoutTypesUpdate = (
    organizationId: number,
    id: number,
    selectedWorkoutType: NonReadonly<SelectedWorkoutType>,
 options?: SecondParameter<typeof adminV1OrganizationsSelectedWorkoutTypesUpdateMutator<SelectedWorkoutType>>,) => {
      return adminV1OrganizationsSelectedWorkoutTypesUpdateMutator<SelectedWorkoutType>(
      {url: `/api/admin/v1/organizations/${organizationId}/selected_workout_types/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: selectedWorkoutType
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsSelectedWorkoutTypesPartialUpdate = (
    organizationId: number,
    id: number,
    patchedSelectedWorkoutType: NonReadonly<PatchedSelectedWorkoutType>,
 options?: SecondParameter<typeof adminV1OrganizationsSelectedWorkoutTypesPartialUpdateMutator<SelectedWorkoutType>>,) => {
      return adminV1OrganizationsSelectedWorkoutTypesPartialUpdateMutator<SelectedWorkoutType>(
      {url: `/api/admin/v1/organizations/${organizationId}/selected_workout_types/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedSelectedWorkoutType
    },
      options);
    }
  export type AdminV1OrganizationsSelectedWorkoutTypesListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsSelectedWorkoutTypesList>>>
export type AdminV1OrganizationsSelectedWorkoutTypesCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsSelectedWorkoutTypesCreate>>>
export type AdminV1OrganizationsSelectedWorkoutTypesUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsSelectedWorkoutTypesUpdate>>>
export type AdminV1OrganizationsSelectedWorkoutTypesPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsSelectedWorkoutTypesPartialUpdate>>>
